import React from 'react';
import styled from '@emotion/styled';

type QRCodeProps = {
  src: string;
  imgAlt?: string;
  size?: number;
};

const ImgContainer = styled.div<{ size: number }>`
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
`;

const Img = styled.img<{ size: number }>`
  max-height: ${({ size }) => size}px;
  max-width: ${({ size }) => size}px;
`;

const QRCode = ({
  src,
  imgAlt = "A QR Code linking to the Zola app on your phone's app store.",
  size = 110,
}: QRCodeProps): JSX.Element => (
  <ImgContainer size={size}>
    <Img src={src} alt={imgAlt} size={size} />
  </ImgContainer>
);

export default QRCode;
